export enum OrderLabelStatus {
  All = 'All',
  New = 'New',
  NotPrinted = 'NotPrinted',
  Printed = 'Printed',
}
